<template>
  <section class="hero-wrapper">
    <!-- 装饰圆环 -->
    <div class="hud-circle" style="width: 50vw; height: 50vw; right: -10vw; top: -10vw; border-color: rgba(0,0,0,0.05);"></div>
    <div class="hud-circle" style="width: 30vw; height: 30vw; right: 10vw; bottom: -10vw; border: 2px dashed rgba(106, 0, 255, 0.1);"></div>
    <!-- 伪代码装饰 -->
    <div class="hud-code">
      SYSTEM_BOOT_SEQUENCE_INIT<br>
      LOADING_MODULES... 100%<br>
      CONNECTING_TO_SERVER... OK<br>
      > READY_TO_LAUNCH
    </div>

    <div class="hero-container">
      <div class="hero-text-group">
        <div class="tag-line">
          <span class="dot"></span>
          <span class="line"></span>
          {{ siteConfig.sitename }}
          <span class="tag-badge">V{{ siteConfig.version }}</span>
        </div>
        <div class="main-title">
          <span class="title-row-1">{{ siteConfig.sitename }}</span>
          <span class="title-row-2">二级域名分发</span>
        </div>
        <div class="desc-box">
          <div class="desc-decor"></div>
          <div class="desc-text">{{ siteConfig.description }}</div>
        </div>
        <div class="btn-group">
          <a href="/user" class="cyber-btn">立即使用 START</a>
          <a href="#announcements" class="cyber-btn ghost">官方公告</a>
        </div>
      </div>
      <div class="hero-char-area">
        <div class="char-placeholder"></div>
        <img :src="heroImage" alt="角色立绘" class="character-image">
      </div>
    </div>

    <!-- 跑马灯区域 -->
    <MarqueeBar />
  </section>
</template>

<script setup>
import { siteConfig, stats } from '../data/data.js'
import MarqueeBar from './MarqueeBar.vue'
import heroImage from '../assets/image.png'
</script>
